module.exports = __webpack_public_path__ + "img/EASTEA_LOGO1.1b818507.jpeg";